export function TeamRequestsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/team-requests.svg'"></ng-include>`
    }
}
            